if(!customElements.get('navigation-sections-tabs')) {
  class ComponentNavigationSectionTabs extends HTMLElement {
    constructor() {
      super();
      var buttons = this.querySelectorAll('.tab-button');
      var lastButtonActive = buttons[0];
      var lastTargetActive = document.getElementById(lastButtonActive.dataset.target);
      if(lastTargetActive)
        lastTargetActive.classList.remove("hide");
      console.log(lastTargetActive, lastButtonActive.dataset.target);
      buttons.forEach(function(item) {
        item.addEventListener('click', function(e){
          e.preventDefault();          
          lastButtonActive.classList.remove('active');
          lastButtonActive = item;
          item.classList.add('active');

          if(lastTargetActive){
            lastTargetActive.classList.add("hide");
            var currentTarget = document.getElementById(item.dataset.target);
            if(currentTarget){
              currentTarget.classList.remove("hide");
              lastTargetActive = currentTarget;
            }
          }
          
        });
      });

    }

    

  }
  customElements.define('navigation-sections-tabs', ComponentNavigationSectionTabs);
}